import { render } from "./AuthorDetail.vue?vue&type=template&id=b8dfd330&scoped=true&ts=true"
import script from "./AuthorDetail.vue?vue&type=script&lang=ts"
export * from "./AuthorDetail.vue?vue&type=script&lang=ts"

import "./AuthorDetail.vue?vue&type=style&index=0&id=b8dfd330&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8dfd330"]])

export default __exports__